import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useImagePreviewUrl = (draftId: string, candidateId: string | undefined) =>
  useQuery({
    queryKey: ["image-preview", draftId, candidateId],
    queryFn: () => api.images.getPreviewUrl(draftId, candidateId!),
    enabled: !!candidateId,
    staleTime: 4 * 60 * 1000, // 4min (presigned dura 5min)
  });
